import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { getAvailableMonths } from '../../../../helpers/localization/localizationUtils';
import Select from '../../../elements/Select';
import Box from '../../../elements/Box';

function formatFunctions(months) {
  return months.map((item, index) => {
    // formatted to (MM YYYY)
    const name = `${item.name} ${item.year}`;
    return {
      name,
      value: index,
      key: name
    };
  });
}

const MonthNavigationDropdown = (props) => {
  const {
    months,
    onSelect,
    showShortMonths,
    navigationDropdownSelect,
    currentMonth: currentDate
  } = props;
  const { direction, translate, localizationData, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const currentMonth = dayjs(currentDate);
  const options = getAvailableMonths(
    months,
    translate,
    localizationData,
    showShortMonths,
    dayjs(currentMonth)
  );
  const index = options[0] ? options[0].month : undefined;
  const onChange = (event) => {
    const month = options[event.target.value];
    onSelect(month);
  };
  const styles = { ...style };
  styles.textAlignLast = 'center';
  return (
    <Box className={className} style={style}>
      <Select
        {...navigationDropdownSelect}
        value={index}
        options={formatFunctions(options)}
        iconRight="keyboard_arrow_down"
        onChange={onChange}
      />
    </Box>
  );
};

MonthNavigationDropdown.propTypes = {
  /**
   * Months to show
   */
  months: PropTypes.number,
  /**
   * Function fire when change month
   */
  onSelect: PropTypes.func,
  /**
   * Function fire when month is lost focus
   */
  onBlur: PropTypes.func,
  /**
   * showShortMonths
   */
  showShortMonths: PropTypes.bool,
  /**
   * Props of navigationDropdownSelect
   */
  navigationDropdownSelect: PropTypes.objectOf(PropTypes.any),
  /**
   * Current selected month
   */
  currentMonth: PropTypes.instanceOf(Date)
};
MonthNavigationDropdown.defaultProps = {
  months: 3,
  onSelect: () => {},
  onBlur: () => {},
  showShortMonths: false,
  navigationDropdownSelect: {},
  currentMonth: dayjs()
};
MonthNavigationDropdown.componentName = 'MonthNavigationDropdown';

export default MonthNavigationDropdown;
